import { myEnterpriseApi } from 'v5/api/enterprise/enterprise.api.connected';
import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { createEnterpriseService } from './EnterpriseService.impl';

export const myEnterpriseService = createEnterpriseService({
  api: myEnterpriseApi,
  queryClient,
  services: {
    errorService: myErrorService
  }
});
